import { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import { downloadCSVFile } from '../GlobalFunctions';
import styles from '../SCSS/Report.module.scss';
import PrimaryButton from '../components/PrimaryButton/PrimaryButton';
import { myBrowserHistory } from '../ApplicationState';

interface JumperProps {
  url: string;
  key: string;
}
class Jumper extends Component<JumperProps, Record<string, never>> {
  render() {
    return (
      <button
        type='button'
        className={styles['button-blue-iconOnly']}
        value={this.props.url}
        onClick={(event) => {
          openUnit(event);
        }}
      >
        <i className='fa fa-sign-in' />
      </button>
    );
  }
}

class SubTable extends Component {
  render() {
    if (this.props.data) {
      return (
        <BootstrapTable data={this.props.data}>
          <TableHeaderColumn width='10%' columnClassName={styles.normalColumnStyle} dataField='CoreStandards' isKey>
            Core Standards
          </TableHeaderColumn>
          <TableHeaderColumn width='30%' columnClassName={styles.normalColumnStyle} dataField='Unit'>
            Unit
          </TableHeaderColumn>
          <TableHeaderColumn width='60%' columnClassName={styles.normalColumnStyle} dataField='Detail'>
            Detail
          </TableHeaderColumn>
        </BootstrapTable>
      );
    }
    return <p>?</p>;
  }
}

class SubTable1 extends Component {
  render() {
    let [width1, width2, width3, width4, width5] = ['25%', '35%', '16%', '16%', '8%'];
    if (window.screen.availWidth < 768) {
      [width1, width2, width3, width4, width5] = ['25%', '25%', '15%', '20%', '15%'];
    }
    if (this.props.data) {
      return (
        <BootstrapTable data={this.props.data}>
          <TableHeaderColumn width={width1} columnClassName={styles.normalColumnStyle} dataField='SubUnit' isKey>
            Sub Unit
          </TableHeaderColumn>
          <TableHeaderColumn width={width2} columnClassName={styles.normalColumnStyle} dataField='Activity'>
            Activity
          </TableHeaderColumn>
          <TableHeaderColumn width={width3} columnClassName={styles.normalColumnStyle} dataField='ActivityType'>
            Activity Type
          </TableHeaderColumn>
          <TableHeaderColumn width={width4} columnClassName={styles.normalColumnStyle} dataField='Status'>
            Status
          </TableHeaderColumn>
          <TableHeaderColumn
            width={width5}
            columnClassName={styles.normalColumnStyle}
            dataField='Jumper'
            dataFormat={activeFormatter}
          />
        </BootstrapTable>
      );
    }
    return <p>?</p>;
  }
}
interface TableReportCardProps {
  data: Record<string, unknown> | Record<string, unknown>[];
  column1: string;
  column2: string;
  column3: string | number | JSX.Element;
  column4: string | number | JSX.Element;
  column5?: string | number | JSX.Element;
  column6?: string | number | JSX.Element;
  column7?: string;
  column8?: string;
  id1: string;
  id2: string;
  id3: string;
  id4: string;
  id5?: string;
  id6?: string;
  id7?: string;
  id8?: string;
  id1Format?: (cellValue: unknown, rowValue: unknown) => JSX.Element;
  id2Format?: (cellValue: unknown, rowValue: unknown) => JSX.Element;
  id3Format?: (cellValue: unknown, rowValue: unknown) => JSX.Element | null;
  id4Format?: (cellValue: unknown, rowValue: unknown) => JSX.Element | null;
  id5Format?: (cellValue: unknown, rowValue: unknown) => JSX.Element | null;
  id6Format?: (cellValue: unknown, rowValue: unknown) => JSX.Element | null;
  id7Format?: (cellValue: unknown, rowValue: unknown) => JSX.Element;
  id8Format?: (cellValue: unknown, rowValue: unknown) => JSX.Element;
  width1?: string;
  width2?: string;
  width3?: string;
  width4?: string;
  width5?: string;
  width6?: string;
  width7?: string;
  width8?: string;
  JumperButtonWidth?: string;
  className?: string;
  trClassName?: string | ((data: unknown, rowIndex: number) => string);
}

export class TableReportCard extends Component<TableReportCardProps, Record<string, never>> {
  constructor(props: TableReportCardProps) {
    super(props);
    TableReportCard.isExpandableRow = TableReportCard.isExpandableRow.bind(this);
  }

  static isExpandableRow(row) {
    if (row.CoreStandards) {
      return true;
    }
    return !!row.detail;
  }

  expandComponent(row) {
    const subTableData = [];
    if (row.CoreStandardsWithInfo) {
      row.CoreStandardsWithInfo.forEach((entry) => {
        subTableData.push({
          CoreStandards: entry.label,
          Unit: entry.sub,
          Detail: entry.text,
        });
      });
      return <SubTable data={subTableData} />;
    }

    if (row.detail) {
      row.detail.forEach((entry) => {
        subTableData.push({
          SubUnit: entry.subUnit,
          Activity: entry.title,
          ActivityType: entry.label,
          Status: entry.status,
          url: entry.url,
        });
      });
      return <SubTable1 data={subTableData} />;
    }
  }

  UNSAFE_componentWillMount() {
    this.CSVData = [];
    this.CSVFileName = 'Peekapak.csv';
  }

  getLessonsCompletionCSVData(data) {
    let csvContent = 'data:text/csv;charset=utf-8,Unit Name,SubUnit,Activity,ActivityType,Status\n';
    data.forEach((entry) => {
      const UnitName = entry.unitName;
      entry.detail.forEach((entry2) => {
        csvContent += `${UnitName},${entry2.subUnit},${entry2.title.replace(',', ':')},${entry2.label},${
          entry2.status
        }\n`;
      });
    });
    return csvContent;
  }

  getCoreStandardsCSVData(data) {
    let csvContent = 'data:text/csv;charset=utf-8,Lesson,SubUnit,Core Standards,Core Standards Unit,Status\n';
    data.forEach((entry) => {
      const Lesson = entry.Lesson;
      const SubUnit = entry.SubUnit;
      const Status = entry.Status;
      entry.CoreStandardsWithInfo.forEach((entry2) => {
        csvContent += `${Lesson.replace(',', ':')},${SubUnit},${entry2.name},${entry2.sub},${Status},${entry2.text}\n`;
      });
    });
    return csvContent;
  }

  getParentsEngagementCSVData(data) {
    let csvContent =
      'data:text/csv;charset=utf-8,Parents of,Invitation Accepted Since,Engagement Score, Story Book Opened Times, Activity Email Opened Times\n';
    data.forEach((entry) => {
      csvContent += `${entry.student},${entry.acceptedTime},${entry.engagementScore},${entry.storyBookOpened},${entry.activityOpened}\n`;
    });
    return csvContent;
  }

  render() {
    const {
      data,
      column1,
      column2,
      column3,
      column4,
      column5,
      column6,
      column7,
      column8,
      id1,
      id2,
      id3,
      id4,
      id5,
      id6,
      id7,
      id8,
      width1,
      width2,
      width3,
      width4,
      width5,
      width6,
      width7,
      width8,
      JumperButtonWidth,
    } = this.props;
    const options = {
      expandRowBgColor: '#ff6319',
      expandBy: 'column',
    };

    const defineCSV = () => {
      if (this.CSVData.length === 0) {
        if (data[0]) {
          if (data[0].CoreStandards) {
            this.CSVData = this.getCoreStandardsCSVData(data);
            this.CSVFileName = 'CoreStandards.csv';
          } else if (data[0].unitName) {
            this.CSVData = this.getLessonsCompletionCSVData(data);
            this.CSVFileName = 'LessonCompletion.csv';
          } else {
            this.CSVData = this.getParentsEngagementCSVData(data);
            this.CSVFileName = 'ParentsEngagement.csv';
          }
        }
      }
    };

    defineCSV();

    let tablewidth = '65%';
    let CSVbuttonDisplay = '';
    let columnStyle = styles.normalColumnStyle;

    const setTableDimenionsAndCharacterstics = () => {
      if (data[0] && data[0].studentName) {
        tablewidth = '100%';
        CSVbuttonDisplay = 'none';
        columnStyle = '';
      } else if (window.screen.availWidth < 768) {
        tablewidth = '95%';
        CSVbuttonDisplay = 'none';
        columnStyle = '';
      }
    };

    setTableDimenionsAndCharacterstics();

    const pickFormat = (inputFormat) => inputFormat || peekapakTableFormat;

    return (
      <div style={{ width: tablewidth, margin: 'auto' }}>
        <span className={styles.CSVButton} style={{ display: CSVbuttonDisplay }}>
          <PrimaryButton
            onClick={() => {
              downloadCSVFile(this.CSVFileName, this.CSVData);
            }}
          >
            <i className='fa fa-download' /> Download CSV File
          </PrimaryButton>
        </span>
        <BootstrapTable
          data={data}
          options={options}
          expandableRow={TableReportCard.isExpandableRow}
          expandComponent={this.expandComponent}
          expandColumnOptions={{ expandColumnVisible: false }}
          search={false}
          bordered={false}
          trClassName={this.props.trClassName}
        >
          {id1 && (
            <TableHeaderColumn
              dataAlign='left'
              width={width1}
              dataField={id1}
              columnClassName={columnStyle}
              dataFormat={pickFormat(this.props.id1Format)}
              isKey
              dataSort={false}
              expandable={false}
            >
              {column1}
            </TableHeaderColumn>
          )}
          {id2 && (
            <TableHeaderColumn
              dataAlign='center'
              width={width2}
              dataField={id2}
              columnClassName={columnStyle}
              dataFormat={pickFormat(this.props.id2Format)}
              dataSort={false}
              expandable={false}
            >
              {column2}
            </TableHeaderColumn>
          )}
          {id3 && (
            <TableHeaderColumn
              dataAlign='center'
              width={width3}
              dataField={id3}
              columnClassName={columnStyle}
              dataFormat={pickFormat(this.props.id3Format)}
              dataSort={false}
              expandable={false}
            >
              {column3}
            </TableHeaderColumn>
          )}
          {id4 && (
            <TableHeaderColumn
              dataAlign='center'
              width={width4}
              dataField={id4}
              columnClassName={columnStyle}
              dataFormat={pickFormat(this.props.id4Format)}
              dataSort={false}
              expandable={false}
            >
              {column4}
            </TableHeaderColumn>
          )}
          {id5 && (
            <TableHeaderColumn
              dataAlign='center'
              width={width5}
              dataField={id5}
              columnClassName={columnStyle}
              dataFormat={pickFormat(this.props.id5Format)}
              dataSort={false}
              expandable={false}
            >
              {column5}
            </TableHeaderColumn>
          )}
          {id6 && (
            <TableHeaderColumn
              dataAlign='center'
              width={width6}
              dataField={id6}
              columnClassName={columnStyle}
              dataFormat={pickFormat(this.props.id6Format)}
              dataSort={false}
              expandable={false}
            >
              {column6}
            </TableHeaderColumn>
          )}
          {id7 && (
            <TableHeaderColumn
              dataAlign='center'
              width={width7}
              dataField={id7}
              columnClassName={columnStyle}
              dataFormat={pickFormat(this.props.id7Format)}
              dataSort={false}
              expandable={false}
            >
              {column7}
            </TableHeaderColumn>
          )}
          {id8 && (
            <TableHeaderColumn
              dataAlign='center'
              width={width8}
              dataField={id8}
              columnClassName={columnStyle}
              dataFormat={pickFormat(this.props.id8Format)}
              dataSort={false}
              expandable={false}
            >
              {column8}
            </TableHeaderColumn>
          )}
          {JumperButtonWidth && (
            <TableHeaderColumn
              width={JumperButtonWidth}
              dataField='Jumper'
              dataFormat={activeFormatter}
              expandable={false}
            />
          )}
        </BootstrapTable>
      </div>
    );
  }
}

function activeFormatter(cell: string, row) {
  const url = row.url;
  if (url) {
    return <Jumper url={url} key={url} />;
  }
  return null;
}
function openUnit(event) {
  if (event.currentTarget.value) {
    myBrowserHistory.push(event.currentTarget.value);
  }
}

function peekapakTableFormat(cellValue) {
  const peekapakTableStyle = { verticalAlign: 'middle' };
  return (
    <div className={styles.peekapakTableFormat} style={peekapakTableStyle}>
      {cellValue}
    </div>
  );
}
